import { render, staticRenderFns } from "./DescriptionPopup.vue?vue&type=template&id=94537036&scoped=true"
import script from "./DescriptionPopup.vue?vue&type=script&lang=js"
export * from "./DescriptionPopup.vue?vue&type=script&lang=js"
import style0 from "./DescriptionPopup.vue?vue&type=style&index=0&id=94537036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94537036",
  null
  
)

export default component.exports